import { styled } from "@mui/material/styles";

export const Root = styled("div", { label: "AppLogo-root" })(({ theme }) => ({
  display: "flex",

  'a': {
    'img': {
      "@media print": {
        marginLeft: 0,
      },
    }
  }

}));

export const LogoImg = styled("img", { label: "AppLogo-img" })(({ theme }) => ({
  cursor: "pointer",
  marginLeft: 20,
  marginRight: 6,
  height: 24,
  marginTop: 5,
}));

export const Environment = styled("div", { label: "AppLogo-environment" })(({ theme }) => ({
  position: "absolute",
  fontSize: 10,
  top: 0,
  left: 0,
  borderBottomRightRadius: 8,
  paddingRight: 10,
  color: "#fff",
  paddingLeft: 5,

  [theme.breakpoints.up("md")]: {
    backgroundColor: "red",
  },

  [theme.breakpoints.down("md")]: {
    backgroundColor: "violet",
  },

  [theme.breakpoints.down("sm")]: {
    backgroundColor: "green",
  },


  "&:first-letter": {
    textTransform: 'uppercase',
  },

  "&:before": {

    [theme.breakpoints.up("md")]: {
      content: "'desktop'",
    },

    [theme.breakpoints.down("md")]: {
      content: "'tablet (non tenerne conto)'",
    },

    [theme.breakpoints.down("sm")]: {
      content: "'mobile (non tenerne conto)'",
    },
  }
}));
